import { SablonaStadiumExternalApi, Stadium } from 'ciselniky-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ClientResponse } from '../../../model/ClientResponse';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import { StadiumMaterialu, StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';

const client = new SablonaStadiumExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(stadiumList: Stadium[]): StadiumMaterialu[] {
  return stadiumList.map(stadium => ({
    hodnota: StadiumMaterialuEnum[stadium.hodnota],
    nazov: stadium.nazov,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchSablonaStadiumList = async (sablonaUuid: string, headers?: object):
  Promise<ClientResponse<StadiumMaterialu[]>> => {
  const {
    data,
    status,
  } = await client.getSablonaStadiumList(sablonaUuid, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
